import React, { useState } from "react";
import PlaceholderIMG from "./placeholderImage";

const ImageSlider = ({ list, wrapperClass = "" }) => {
	const [active, setActive] = useState(0);

	const prev = () => {
		const value = active === 0 ? list.length - 1 : active - 1;
		setActive(value);
	};

	const next = () => {
		const value = active === list.length - 1 ? 0 : active + 1;
		setActive(value);
	};

	return (
		<div className={`image-slider-wrap ${wrapperClass}`}>
			{list && list.length > 1 ? (
				<div className="image-slider-prev" onClick={prev}>
					<i className="icon icon-angle-left" />
				</div>
			) : null}
			<div className="image-slider-container">
				{list && list.length > 0 ? (
					list.map((item, index) => {
						return (
							<div key={index} className={`slider-item ${active === index ? "active" : ""}`}>
								<PlaceholderIMG
									src={item.src}
									objectFit="cover"
									width="800"
									height="500"
									bg="rgba(0,0,0,0.1)"
									color="rgba(0,0,0,0.3)"
								/>
							</div>
						);
					})
				) : (
					<PlaceholderIMG objectFit="cover" width="800" height="500" bg="rgba(0,0,0,0)" color="rgba(0,0,0,0.3)" />
				)}
			</div>
			{list && list.length > 1 ? (
				<div className="image-slider-next" onClick={next}>
					<i className="icon icon-angle-right" />
				</div>
			) : null}
		</div>
	);
};

export default ImageSlider;
